<template>
  <input-select
    id="lgbtq"
    :value="value"
    name="lgbtq"
    label="LGBTQ+ Status"
    placeholder="Prefer not to say"
    placeholder-enabled
    :options="[
      { id: 'true', display_label: 'LGBTQ+' },
      { id: 'false', display_label: 'Not LGBTQ+' }
    ]"
    @input="val => $emit('input', val)"
  />
</template>

<script>
import InputSelect from '@/components/inputs/InputSelect.vue';

export default {
  name: 'LgbtqPicker',

  components: {
    InputSelect
  },

  props: {
    value: {
      type: String,
      required: true
    }
  },
};
</script>
